// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input {\n  margin: .8rem 0;\n}\n\n\n.input .group {\n  display: grid;\n  grid-template-columns: 1fr 50px;\n  grid-gap: 1rem;\n  gap: 1rem;\n}\n\n.input strong {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  grid-gap: .5rem;\n  gap: .5rem;\n}\n\n.input .group input[type=\"number\"] {\n  border: none;\n  outline: none;\n}", ""]);
// Exports
module.exports = exports;
